import {
  del,
  get,
  post,
  postContract,
  postContractV2,
  postFileAffiliation,
  postMultipart,
  put,
} from '@webapps/utils';
import { format } from 'path';

const { NX_REST_API } = process.env;

export const getInfosSchool = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/${id}`,
    }),
  format: ({ data }) => data,
};

export const getSchoolsModules = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/modules/${id}`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant la liste des partenaires d'une école
 * @param id - Identifiant de l'école
 * @param page - numéro de page
 * @param size - taille de la page
 * @param type - statut du partenariat
 */
export const getSchoolsPartners = {
  query: ({ id, page, size, type }) =>
    get({
      url: `${NX_REST_API}/partners/school/${id}?type=${type}&page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const searchSchoolsPartners = {
  query: ({
    accept,
    domains,
    from,
    id,
    individual,
    keyword,
    page,
    sectors,
    size,
    type,
  }) =>
    get({
      url: `${NX_REST_API}/partners/school/search/${id}?accept=${accept}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
          ...(domains ? { domains } : {}),
          ...(sectors ? { sectors } : {}),
          ...(type ? { type } : {}),
          ...(from ? { from } : {}),
          ...(individual ? { individual } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de partenaire d'une école
 * @param {number} id - Identifiant de l'école
 */
export const getSchoolsPartnersCount = {
  query: ({ id, page, size, type }) =>
    get({
      url: `${NX_REST_API}/partners/school/${id}/count`,
    }),
  format: ({ data }) => data,
};

export const getSchools = {
  query: () =>
    get({
      url: `${NX_REST_API}/schools`,
      // options: {
      //   params: {
      //     ...(page ? { page } : {}),
      //     ...(size ? { size } : {}),
      //   },
      // },
    }),
  format: ({ data }) => data,
};

export const getSchoolsPagination = {
  query: ({ page, size }) =>
    get({
      url: `${NX_REST_API}/schools`,
      options: {
        params: {
          ...(page ? { page } : {}),
          ...(size ? { size } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getSchoolSize = {
  query: () =>
    get({
      url: `${NX_REST_API}/settings/module/organization_size`,
    }),
  format: ({ data }) => data,
};

export const getSchoolSectors = {
  query: () =>
    get({
      url: `${NX_REST_API}/settings/module/activity_sector`,
    }),
  format: ({ data }) => data,
};

export const getSpecializationsBySector = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/settings/module/specialization/sector/${id}`,
    }),
  format: ({ data }) => data,
};

export const createFormation = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/trainings`,
      data,
    }),
};

export const updateFormation = {
  query: ({ data, id, from }) =>
    put({
      url: `${NX_REST_API}/trainings/${id}`,
      options: {
        params: {
          ...(from ? { from } : {}),
        },
      },
      data,
    }),
};

export const deleteFormation = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/trainings/${id}`,
    }),
};

export const getSpecializations = {
  query: () =>
    get({
      url: `${NX_REST_API}/settings/module/specialization`,
    }),
  format: ({ data }) => data,
};

export const getAddress = {
  query: ({ name }) =>
    get({
      url: `https://api-adresse.data.gouv.fr/search/?q=${name}&limit=5`,
    }),
  format: ({ data }) => data,
};

export const getCommunes = {
  query: ({ name }) =>
    get({
      url: `https://geo.api.gouv.fr/communes?nom=${name}&fields=departement&boost=population&limit=5`,
    }),
  format: ({ data }) => data,
}

export const updateSchoolInfoVitrine = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/schools/${id}`,
      data,
    }),
};

export const postMatiereSchool = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/schools/module/modules/${id}`,
      data,
    }),
};

export const deleteMatiereSchool = {
  query: ({ data, id }) =>
    del({
      url: `${NX_REST_API}/schools/module/modules/${id}`,
      data,
    }),
};

export const getTrainingDomains = {
  query: () =>
    get({
      url: `${NX_REST_API}/trainings/module/domains?page=0&size=1000`,
    }),
  format: ({ data }) => data,
};

export const getCertificationAuthority = {
  query: () =>
    get({
      url: `${NX_REST_API}/trainings/module/certifying_authorities`,
    }),
  format: ({ data }) => data,
};

export const getTrainingType = {
  query: () =>
    get({
      url: `${NX_REST_API}/trainings/module/training_types`,
    }),
  format: ({ data }) => data,
};

export const getStudyPlan = {
  query: () =>
    get({
      url: `${NX_REST_API}/trainings/module/study_plans`,
    }),
  format: ({ data }) => data,
};

export const getDegreeLevel = {
  query: () =>
    get({
      url: `${NX_REST_API}/trainings/module/degrees`,
    }),
  format: ({ data }) => data,
};

export const getDegreeRequirements = {
  query: () =>
    get({
      url: `${NX_REST_API}/trainings/module/degree_levels`,
    }),
  format: ({ data }) => data,
};

export const getDegree = {
  query: () =>
    get({
      url: `${NX_REST_API}/trainings/module/degrees`,
    }),
  format: ({ data }) => data,
};

export const getLangFormation = {
  query: () =>
    get({
      url: `${NX_REST_API}/trainings/module/worked_languages`,
    }),
  format: ({ data }) => data,
};

export const getSchoolFormations = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/trainings/school/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getSchoolClassrooms = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/school/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getFormationsMap = {
  query: ({
    cities,
    degrees,
    domains,
    keyword,
    page,
    schools,
    cfas,
    size,
    studyPlans,
    trainingTypes,
  }) =>
    get({
      url: `${NX_REST_API}/trainings/search?page=${page}&size=${size}`,
      options: {
        params: {
          ...(schools ? { schools } : {}),
          ...(cfas ? { cfas } : {}),
          ...(cities ? { cities } : {}),
          ...(domains ? { domains } : {}),
          ...(degrees ? { degrees } : {}),
          ...(keyword ? { keyword } : {}),
          ...(trainingTypes ? { trainingTypes } : {}),
          ...(studyPlans ? { studyPlans } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getSchoolsSearch = {
  query: ({
    degreeLevels,
    keyword,
    page,
    size,
    trainingDomains,
    trainingTypes,
    businessId,
  }) =>
    get({
      url: `${NX_REST_API}/schools/search?page=${page}&size=${size}&keyword=${keyword}`,
      options: {
        params: {
          ...(trainingDomains ? { trainingDomains } : {}),
          ...(degreeLevels ? { degreeLevels } : {}),
          ...(trainingTypes ? { trainingTypes } : {}),
          ...(businessId ? { businessId } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const deleteABusinessPartner = {
  query: ({ businessId, schoolId }) =>
    del({
      url: `${NX_REST_API}/partners/delete?businessId=${businessId}&schoolId=${schoolId}&from=school`,
    }),
};

export const deleteABusinessExternal = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/partners/school/delete-business-external?businessExternalId=${id}`,
    }),
};

export const rejectABusinessPartner = {
  query: ({ businessId, schoolId }) =>
    put({
      url: `${NX_REST_API}/partners/reject?businessId=${businessId}&schoolId=${schoolId}`,
    }),
};

export const acceptABusinessPartner = {
  query: ({ businessId, schoolId }) =>
    put({
      url: `${NX_REST_API}/partners/accept?businessId=${businessId}&schoolId=${schoolId}`,
    }),
};

export const connectABusinessPartner = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/partners/connect?connect_type=schoolToBusiness`,
      data,
    }),
};

/**
 * Service retournant le nombre d'affiliation reçue
 * @param {number} id - Identifiant de l'école
 */
export const getAffiliationCount = {
  query: ({ id, page, size, type }) =>
    get({
      url: `${NX_REST_API}/affiliates/school/${id}/count`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre d'affiliation acceptée
 * @param {number} id - Identifiant de l'école
 */
export const getAcceptedAffiliationCount = {
  query: ({ id, page, size, type }) =>
    get({
      url: `${NX_REST_API}/affiliates/school/${id}/count?status=enclosed`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre d'affiliation refusée
 * @param {number} id - Identifiant de l'école
 */
export const getCanceledAffiliationCount = {
  query: ({ id, page, size, type }) =>
    get({
      url: `${NX_REST_API}/affiliates/school/${id}/count?status=rejected,canceled,broken`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre d'affiliation en attente
 * @param {number} id - Identifiant de l'école
 */
export const getWaitingAffiliationCount = {
  query: ({ id, page, size, type }) =>
    get({
      url: `${NX_REST_API}/affiliates/school/${id}/count?status=created,accepted,half-rejected`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant la liste des candidatures reçues d'une école
 * @param {number} id - identifiant de l'école
 * @param {page} page - numéro de page
 * @param {status} status - statut de la candidature (ACCEPTED, REJECTED, PENDING)
 * @param {size} size - nombre de candidature par page
 */
export const getCandidature = {
  query: ({
    degree,
    id,
    interestLevel,
    isRead,
    keyword,
    page,
    size,
    status,
    training,
    trainingType,
  }) =>
    get({
      url: `${NX_REST_API}/trainings/module/applications/school/${id}?page=${page}&size=${size}`,
      options: {
        params: {
          ...(status ? { status } : {}),
          ...(keyword ? { keyword } : {}),
          ...(training ? { training } : {}),
          ...(degree ? { degree } : {}),
          ...(interestLevel ? { interestLevel } : {}),
          ...(isRead ? { isRead } : {}),
          ...(trainingType ? { trainingType } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de candidature reçue
 * @param id - Identifiant de l'école
 */
export const getSchoolCandidatureCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/module/applications/school/${id}/count?status=all`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de candidature acceptée
 * @param id - Identifiant de l'école
 */
export const getSchoolAcceptedCandidatureCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/module/applications/school/${id}/count?status=accepted`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de candidature en attente
 * @param id - Identifiant de l'école
 */
export const getSchoolPendingCandidatureCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/module/applications/school/${id}/count?status=pending`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de candidature refusée
 * @param id - Identifiant de l'école
 */
export const getSchoolRejectedCandidatureCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/module/applications/school/${id}/count?status=rejected`,
    }),
  format: ({ data }) => data,
};

export const postCreateClasse = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/schools/module/classrooms/school/${id}`,
      data,
    }),
};

export const postUpdateClasse = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/schools/module/classrooms/${id}`,
      data,
    }),
};

export const deleteClasse = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/schools/module/classrooms/${id}`,
    }),
};

export const getClasses = {
  query: ({ degree, id, keyword, page, size, training, trainingType }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/school/${id}?page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
          ...(training ? { training } : {}),
          ...(degree ? { degree } : {}),
          ...(trainingType ? { trainingType } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getClassesById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/${id}`,
    }),
  format: ({ data }) => data,
};

export const getNumberFormationById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/school/${id}/count?status=opened`,
    }),
  format: ({ data }) => data,
};

export const getClassrommsById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/school/${id}?page=0&size=10000`,
    }),
  format: ({ data }) => data,
};

export const getClassroomsByCFA = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/cfa/${id}`,
    }),
  format: ({ data }) => data,
}

export const createSchoolAffiliate = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/affiliates/school_affiliate`,
      data,
    }),
};

export const getExternalBusinessDataFromSiret = {
  query: ({ id }) =>
    get({
      url: `https://api.insee.fr/api-sirene/3.11/siret/${id}`,
      options: {
        headers: {
          Accept: 'application/json',
          'X-INSEE-Api-Key-Integration': '0cba103f-8e08-4165-ba10-3f8e08516506',
        },
      },
    }),
  format: ({ data }) => data,
};

export const createExternalBusiness = {
  query: ({ formData }) =>
    postMultipart({
      url: `${NX_REST_API}/partners/school/business/external`,
      formData,
    }),
};

export const getSchoolAffiliate = {
  query: ({ id, keyword, page, size, status, training }) =>
    get({
      url: `${NX_REST_API}/affiliates/school/${id}?page=${page}&size=${size}`,
      options: {
        params: {
          ...(training ? { training } : {}),
          ...(keyword ? { keyword } : {}),
          ...(status ? { status } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const acceptApplicant = {
  query: ({ applicantId, trainingId }) =>
    put({
      url: `${NX_REST_API}/trainings/module/applications/accept?applicantId=${applicantId}&trainingId=${trainingId}`,
    }),
};

export const rejectApplicant = {
  query: ({ applicantId, trainingId }) =>
    put({
      url: `${NX_REST_API}/trainings/module/applications/reject?applicantId=${applicantId}&trainingId=${trainingId}`,
    }),
};

export const getCountCandidatByFormation = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/module/applications/training/${id}/count?status=all`,
    }),
  format: ({ data }) => data,
};

export const interestLevelTraining = {
  query: ({ applicantId, level, trainingId }) =>
    put({
      url: `${NX_REST_API}/trainings/module/applications/interest_level?level=${level}&trainingId=${trainingId}&applicantId=${applicantId}`,
    }),
};

export const postAffilationFiles = {
  query: ({ data }) =>
    postFileAffiliation({
      url: `${NX_REST_API}/affiliates/attachments`,
      data,
    }),
};

export const getTrainingById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/${id}`,
    }),
  format: ({ data }) => data,
};

export const inviteStudentSchool = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/affiliates/invite/students`,
      data,
    }),
};

export const acceptOrRejectStudentAttachment = {
  query: ({ action, comments, id }) =>
    put({
      url: `${NX_REST_API}/affiliates/attachments/${id}?action=${action}&comments=${comments}`,
    }),
};

export const getStudentOnClass = {
  query: ({ id, keyword, page, size, status }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/classroom/${id}?status=${status}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getStudentOnSchool = {
  query: ({ id, keyword, page, size, status }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/school/members/${id}?status=${status}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

// export const getStudentOnClass = {
//   query: ({ id, keyword, page, size }) =>
//     get({
//       url: `${NX_REST_API}/schools/module/classrooms/${id}/students?status=ENROLLED&page=${page}&size=${size}`,
//       options: {
//         params: {
//           ...(keyword ? { keyword } : {}),
//         },
//       },
//     }),
//   format: ({ data }) => data,
// };

/**
 * Service retournant le nombre de contrats à envoyer d'une école
 * @param {number} id - identifiant de l'école
 */
export const getSchoolContractsToSendCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/affiliates/contracts/school/${id}/to-send/count`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de contrats à signer d'une école
 * @param {number} id - identifiant de l'école
 */
export const getSchoolContractsToSignCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/affiliates/contracts/school/${id}/to-sign/count`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de contrats en attentes de signature d'une école
 * @param {number} id - identifiant de l'école
 */
export const getSchoolContractsCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/affiliates/contracts/school/${id}/count?status=unsigned`,
    }),
  format: ({ data }) => data,
};

export const sendContractFromSchool = {
  query: ({ data }) =>
    postContractV2({
      url: `${NX_REST_API}/affiliates/contracts`,
      data,
    }),
};

export const updateSchoolContract = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/schools/contract/${id}`,
      data,
    }),
};


export const postContractFiles = {
  query: ({ data, id }) =>
    postContract({
      url: `${NX_REST_API}/affiliates/contracts/${id}/attachments`,
      data,
    }),
};

/**
 * Méthode retournant le nombre d'offres d'emploi des partenaires
 * @param {string} id - identifiant d'une école
 */
export const getSchoolPartnersOffersCount = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/partners/school/${id}/count`,
    }),
  format: ({ data }) => data,
};

/**
 * Méthode retournant le nombre d'apprenant chez un partenaires
 * @param {string} id - identifiant d'une école
 */
export const getSchoolStudentsAtPartnerCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/school/${id}/at-partners/count`,
    }),
  format: ({ data }) => data,
};

export const getClassroomLink = {
  query: ({ link }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/link/${link}`,
    }),
  format: ({ data }) => data,
};

export const createClassroomLink = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/schools/module/classrooms/link`,
      data,
    }),
};

export const checkAffiliateStudentOrganization = {
  query: ({ organizationId, studentId }) =>
    get({
      url: `${NX_REST_API}/affiliates/exists?organization=${organizationId}&student=${studentId}`,
    }),
  format: ({ data }) => data,
};

export const getStatsClassRoom = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/classroom/${id}/stats`,
    }),
  format: ({ data }) => data,
};

export const getClassroomInfoById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/${id}`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de classe d'une école
 * @param id - Identifiant de l'école
 */
export const getClassroomCount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/school/${id}/countclassroombyschool`,
    }),
  format: ({ data }) => data,
};

/**
 * Service retournant le nombre de classe en formation initiale d'une école
 * @param id - Identifiant de l'école
 */
export const getFormationTypeClassroomCount = {
  query: ({ id, trainingTypeId }) =>
    get({
      url: `${NX_REST_API}/schools/${id}/count/${trainingTypeId}`,
    }),
  format: ({ data }) => data,
};

export const generateCode = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/affiliates/code/new/${id}`,
      data,
    }),
  format: ({ data }) => data,
};

export const getCode = {
  query: ({ id, type }) =>
    get({
      url: `${NX_REST_API}/affiliates/code/retrieve/${id}?type=${type}`,
    }),
  format: ({ data }) => data,
};

export const redeemCode = {
  query: ({ code, id }) =>
    post({
      url: `${NX_REST_API}/affiliates/code/${code}?id=${id}`,
    }),
  format: ({ data }) => data,
};

export const getDocuments = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/individual/module/documents/owner/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getDocumentsByOrganism = {
  query: ({ idOrganism, idStudent, page, size }) =>
    get({
      url: `${NX_REST_API}/individual/module/documents/organization/${idOrganism}/student/${idStudent}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getDocumentsSchool = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/schools/module/documents/owner/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getInfoSchoolDocument = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/documents/${id}`,
    }),
  format: ({ data }) => data,
};

export const getStudentsInviteSchool = {
  query: ({ email, group, id, page, size, status, year }) =>
    get({
      url: `${NX_REST_API}/affiliates/invites/organization/${id}?&page=${page}&size=${size}`,
      options: {
        params: {
          ...(status ? { status } : {}),
          ...(email ? { email } : {}),
          ...(group ? { group } : {}),
          ...(year ? { year } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const addViewSchool = {
  query: ({ id }) =>
    put({
      url: `${NX_REST_API}/schools/view/${id}`,
    }),
};

export const addViewTraining = {
  query: ({ id }) =>
    put({
      url: `${NX_REST_API}/trainings/view/${id}`,
    }),
};

export const addCfaToTraining = {
  query: ({ id, cfaId }) =>
    put({
      url: `${NX_REST_API}/trainings/cfa/${id}?cfaId=${cfaId}`,
    }),
};

export const getTrainingDate = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/${id}/dates`,
    }),
  format: ({ data }) => data,
};

export const getStudentOnSchoolV2 = {
  query: ({ classes, id, keyword, page, size, status }) =>
    get({
      url: `${NX_REST_API}/schools/${id}/students?status=${status}&classroomId=${classes}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getSchoolNameByClassroomId = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/${id}/school-name`,
    }),
  format: ({ data }) => data,
};

export const getWorkStudyCycleByTrainingId = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/${id}/work-study-cycle`,
    }),
  format: ({ data }) => data,
}

export const exportClassroomsStatement = {
  query: ({ classroomIds, startDate, endDate }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/absence-statement`,
      options: {
        params: {
          classroomIds,
          startDate,
          endDate,
        },
      }
    })
}

export const getPlanningByClassroom = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/${id}/planning`,
    }),
  format: ({ data }) => data,
}

export const addStudentToABusinessWithoutTeam = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/affiliates/invite/student/${data.studentId}/business/${data.businessId}`,
      data,
    }),
}

export const getDayCourses = {
  query: ({ date, classroomId }) =>
    get({
      url: `${NX_REST_API}/schools/module/schedule/courses/day?date=${date}&classroomId=${classroomId}`,
    }),
  format: ({ data }) => data,
}

export const addCourse = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/schools/module/schedule/course?classroomId=${data.classroomId}`,
      data
    }),
}

export const editCourse = {
  query: ({ data }) =>
    put({
      url: `${NX_REST_API}/schools/module/schedule/course/${data.id}`,
      data,
    }),
}

export const deleteCourse = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/schools/module/schedule/course/${id}`,
    }),

}

export const deleteRoom = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/schools/module/schedule/room/${id}`,
    }),
}

export const deleteTeacher = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/schools/module/schedule/teacher/${id}`,
    }),
}

export const createRoom = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/schools/module/schedule/room`,
      data,
    }),
}

export const createTeacher = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/schools/module/schedule/teacher`,
      data,
    }),
}


export const getTeachers = {
  query: () =>
    get({
      url: `${NX_REST_API}/schools/module/schedule/teachers`,
    }),
  format: ({ data }) => data,
}

export const getRooms = {
  query: () =>
    get({
      url: `${NX_REST_API}/schools/module/schedule/rooms`,
    }),
  format: ({ data }) => data,
}

export const getConfigurationStatus = {
  query: ({ id, startDate, endDate }) =>
    get({
      url: `${NX_REST_API}/schools/module/schedule/classroom/${id}/configuration-status?startDate=${startDate}&endDate=${endDate}`,
    }),
  format: ({ data }) => data,
}

export const getClassroomDates = {
  query: ({ classroomId }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/${classroomId}/dates`,
    }),
  format: ({ data }) => data,
}

export const getClassroomPlanning = {
  query: ({ classroomId }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/${classroomId}/planning`,
    }),
  format: ({ data }) => data,
}

export const getPeriodSummary = {
  query: ({ classroomId, startDate, endDate }) =>
    get({
      url: `${NX_REST_API}/schools/module/planning/classroom/${classroomId}/period-summary?startDate=${startDate}&endDate=${endDate}`,
    }),
  format: ({ data }) => data,
}

export const getLastQRCode = {
  query: ({ classroomId }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/qr-code/last?classroomId=${classroomId}`,
    }),
  format: ({ data }) => data,
}

export const refreshQRCode = {
  query: ({ classroomId }) =>
    post({
      url: `${NX_REST_API}/schools/module/classrooms/qr-code/refresh?classroomId=${classroomId}`,
    }),
  format: ({ data }) => data,
}

export const getAllQRCode = {
  query: ({ classroomId, date }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/qr-code/today/stats?classroomId=${classroomId}&date=${date}`,
    }),
  format: ({ data }) => data,
}

export const generateQRCode = {
  query: ({ classroomId }) =>
    post({
      url: `${NX_REST_API}/schools/module/classrooms/qr-code/create?classroomId=${classroomId}`,
    }),
  format: ({ data }) => data,
}
// http://localhost:8080/schools/module/classrooms/emergence/cron
export const launchCron = {
  query: () =>
    post({
      url: `${NX_REST_API}/schools/module/classrooms/emergence/cron`,
    }),
  format: ({ data }) => data,
}

export const scanQRCode = {
  query: ({ studentId, token }) =>
    post({
      url: `${NX_REST_API}/schools/module/classrooms/emergence/scan?studentId=${studentId}&token=${token}`,
    }),
  format: ({ data }) => data,
}

